export default function getListDivisions(data) {
  let divisions = [];
  for (let item of data) {
    if (!divisions.includes(item.division)) {
      divisions.push(item.division);
    }
  }
  return divisions;
}
